import { createSlice } from "@reduxjs/toolkit";
import { checkMediaUrlThunk, createMediaCenter, deleteMedia, getfolder, getmedia, getMoveFolder, getVideo, mediaMove , getmediaByProduct, getfolderByProduct } from "./thunk";

export const initialState: any = {
  mediaList: [],
  counts: {},
  mediaCounts : {},
  folderCounts :  {},
  folders: [],
  moveToFolders: [],
  mediaByProduct : [],
  folderByProduct : [],
  videosList:[],
  urlCheckResult: null,
  loading: false,
  error: null,
};

const MediaSlice = createSlice({
  name: "MediaSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getmedia.fulfilled, (state, action) => {
      // const data = action.payload || [];
      const { data, counts } = action.payload || [];
      state.mediaList = data;
      state.mediaList = data;
      state.counts = counts;
    });
    builder.addCase(getVideo.fulfilled, (state, action) => {
      const { data, counts } = action.payload || [];
      state.videosList = data;
      state.videosList = data;
      state.counts = counts;
    });

    builder.addCase(createMediaCenter.fulfilled, (state: any, action: any) => {
      if(!state.mediaList){
        state.mediaList = [];
      }
      const newMedia = action.payload;
      if (newMedia) {
        state.mediaList = [...state.mediaList, newMedia];
      }
    });

    builder.addCase(deleteMedia.fulfilled, (state: any, action: any) => {
      const idToDelete = action.payload;
      if(!state.mediaList){
        state.mediaList = [];
      }
      if (idToDelete) {
        state.mediaList = state.mediaList.filter((media: any) => media._id !== idToDelete);
      }
    });
    builder.addCase(deleteMedia.rejected, (state: any, action: any) => {
      state.error = action.payload.error || 'Failed to delete product';
    });
    builder.addCase(getfolder.fulfilled, (state, action) => {
      const { data, counts } = action.payload || [];
      state.folders = data;
      state.counts = counts;

    });
    // builder.addCase(getMediaByFolderID.fulfilled, (state: any, action: any) => {
    //   console.log("Fulfilled payload:", JSON.stringify(action.payload, null, 2));
    //   if (action.payload) {
    //     const data = action.payload.data || {};
    //     console.log("Extracted data:", data); // Add this log
    //     state.mediaList = data || [];
    //   }
    // });

    // builder.addCase(getMediaByFolderID.rejected, (state: any, action: any) => {
    //   state.error = action.payload?.message || "Failed to fetch media by folder ID";
    // });
    builder.addCase(checkMediaUrlThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.urlCheckResult = action.payload;
    });
    builder.addCase(checkMediaUrlThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action;
    });
    builder.addCase(mediaMove.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.data = action.payload;
    })
    builder.addCase(mediaMove.rejected, (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.error = action.payload;
    });
    builder.addCase(getMoveFolder.fulfilled, (state, action) => {
      const { data, counts } = action.payload || [];
      state.moveToFolders = data;
      state.counts = counts;
    });
    builder.addCase(getmediaByProduct.fulfilled, (state, action) => {
      const { data, counts } = action.payload || [];
      state.mediaByProduct = data;
      state.mediaCounts = counts;
    });
    builder.addCase(getfolderByProduct.fulfilled, (state, action) => {
      const { data, counts } = action.payload || [];
      state.folderByProduct = data;
      state.folderCounts = counts;

    });
  },
});

export default MediaSlice.reducer;
